import { Divider, Paper, Typography, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Map from '../../../components/Map';
import MapMarker from '../../../components/MapMarker';
import { i18n } from '../../../translate/i18n';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/types';

const MapCard: React.FC = () => {

  const selectedService = useSelector((state: RootState) => state.editService.selectedService);

  const [latitude, setLatitude] = useState<number>(-15.7975);
  const [longitude, setLongitude] = useState<number>(-47.8919);
  const [mapRef, setMapRef] = useState<google.maps.Map>();
  const [mapCenter, setMapCenter] = useState<google.maps.LatLngLiteral>({ lat: -15.7975, lng: -47.8919 });
  const [showMap, setShowMap] = useState<boolean>(false);

  const isValid = (value: string) => {
    return (value !== '' && value !== 'no-authorization' && value !== "permission-not-granted")
  }

  useEffect(() => {
    if(isValid(selectedService.latitude) && isValid(selectedService.longitude)) {
      setLongitude(+selectedService.longitude);
      setLatitude(+selectedService.latitude);
      setMapCenter({ lat: +selectedService.latitude, lng: +selectedService.longitude})
      setShowMap(true);
    } else {
      setShowMap(false);
    }
  }, [selectedService])

  const handleChangeMarker = (event: google.maps.MapMouseEvent) => {
    if (event.latLng) {
      setLatitude(event.latLng.lat());
      setLongitude(event.latLng.lng());
    }
  }

  const handleMapCenter = () => {
    const center = mapRef?.getCenter();
    center && setMapCenter({ lat: center.lat(), lng: center.lng() })
  }

  return(
    <Paper sx={sxs.mapCardContainer}>
      <Typography variant='h6'>
        {i18n.t('editService.localization') as string}
      </Typography>
      <Divider />
      { showMap ? 
        <Map
          center={mapCenter}
          mapType='roadmap'
          onClick={(e: google.maps.MapMouseEvent) => handleChangeMarker(e)}
          onLoad={(map: google.maps.Map) => setMapRef(map)}
          onDragEnd={() => handleMapCenter()}
          zoom={isValid(selectedService.latitude) ? 18 : 2}
          items={[<MapMarker
            key="marker"
            draggable={false}
            handleDrag={(e: google.maps.MapMouseEvent) => handleChangeMarker(e)}
            title={`Marker`}
            latitude={latitude}
            longitude={longitude}
            handleClick={(e: google.maps.MapMouseEvent) => handleChangeMarker(e)}
          />]}
        />
        :
        <Box sx={sxs.noMapContainer}>
          <Typography sx={sxs.noMaplabel}>
            {i18n.t('editService.noCoordinates') as string}
          </Typography>
        </Box>
      }
      
    </Paper>
  )
}

const sxs = {
  mapCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '490px',
    width: '50%',
    gap: 3,
    padding: '24px 24px',
    borderRadius: '12px',
    border: '1px solid var(--primary-hover, #ECEEF3)',
    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.20), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
  },
  noMapContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  noMaplabel: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  }
}

export default MapCard;
